import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <div className='footer'>
      <p>&copy; Copyright 2020 - </p>
      <p>All rights reserved. Powered by Skye_D Projects</p>
    </div>
  );
}

export default Footer;
